import redial from 'redial';
import {withLegacyProviders} from '../../LegacyComponentWrapper';

import Page from '@aboutyou/legacy-desktop/src/app/pages/SEO/BlackFriday/BlackFriday';
import redialHandle from '@aboutyou/legacy-desktop/src/app/pages/SEO/BlackFriday/redial';

const PageWithRedial = redial.provideHooks(redialHandle)(Page);

export const BlackFriday = withLegacyProviders(PageWithRedial);
